import { useState } from 'react';

import { Chip, Tooltip } from '@mui/material';

import { palette } from 'src/theme/palette';
import { GetProfileQuery } from 'src/graphql/generated';

import Iconify from 'src/components/iconify';
import { ConfirmDialogLargeButtons } from 'src/components/custom-dialog';

type ZCoinsComponentType = {
  profile: GetProfileQuery;
};

export default function ZCoinsComponent({ profile }: ZCoinsComponentType) {
  const connectedStore = profile?.me?.connectedStore || null;
  const [showModal, setShowModal] = useState(false);

  const zCoinsFormatted = (connectedStore?.availableNotificationCredits || 0).toLocaleString(
    'pt-BR'
  );

  return (
    <>
      <Tooltip title={`${zCoinsFormatted} ZCoins`} placement="bottom">
        <Chip
          variant="outlined"
          icon={
            <Iconify icon="tabler:coin-filled" color={palette('light').primary.main} width={20} />
          }
          label={zCoinsFormatted}
          onClick={() => setShowModal(true)}
          sx={{ borderRadius: '20px', fontSize: '0.85rem' }}
        />
      </Tooltip>

      <ConfirmDialogLargeButtons
        open={showModal}
        onClose={() => setShowModal(false)}
        title="Precisa de mais ZCoins?"
        content="Gostaria de adquirir mais créditos? Vamos te mostrar nossos pacotes disponíveis para você escolher o que melhor te atende."
        showZekiIllustration
        submitButton={{
          label: 'Ver Pacotes',
          onClick: () =>
            window.open(
              'https://api.whatsapp.com/send/?phone=5511971048980&text=Ol%C3%A1,%20quero%20ver%20pacotes%20de%20ZCoins',
              '_blank'
            ),
        }}
      />
    </>
  );
}
